import { useEffect, useState } from "react";

/**
 * Termo de busca "estabilizado": só muda depois que o usuário para de digitar
 * e, como na versão anterior, só busca com 2+ caracteres (ou campo vazio).
 */
export function useTermoComAtraso(valor: string, atrasoMs = 250, minimo = 2): string {
  const [termo, setTermo] = useState(valor.trim());
  useEffect(() => {
    const t = valor.trim();
    if (t.length > 0 && t.length < minimo) return;
    const id = setTimeout(() => setTermo(t), atrasoMs);
    return () => clearTimeout(id);
  }, [valor, atrasoMs, minimo]);
  return termo;
}
